import { defaultLinks } from "../config/defaults";

const getIsFirstVisit = () => {
    if (localStorage.getItem('firstVisit')) {
        return false;
    } else {
        localStorage.setItem('firstVisit', false);
        return true;
    }
}

const getIsWelcomeModal = () => {
    if (localStorage.getItem('firstVisit')) {
        return true;
    } else {
        return false;
    }
}

const linksGenerator = async () => {
    try {
        const response = await fetch('./js/links.json').then(res => res.json());
        return response;
    } catch (error) {
        console.log("JSON file not found");
        return defaultLinks;
    }
}

async function handleAcceptButton(isEdited) {
    if (this.state.selectedModel) {
        const definedLinks = await linksGenerator();
        let link = "";
        switch (this.state.selectedModel) {
            case "wholesale":
                link = definedLinks.b2b + "?model=b2b";
                break;
            default:
                link = definedLinks.b2c + "?model=b2c";
                break;
        }
        link += `&lang=${this.props.lang}`;
        if (isEdited && this.props.isEditedTemplate) {
            link += "&edited=true";
        } else if ( this.props.isEditedTemplate === false || this.props.notFirstVisit === true) {
            link += "&edited=false";
        }
        window.location.href = link;
    }
}

export { linksGenerator, getIsFirstVisit, getIsWelcomeModal, handleAcceptButton };


// WEBPACK FOOTER //
// ./src/utils/welcomePageUtils.js